import React from 'react';

import Middle from "../Middle";

export default class BlankMediaList extends React.Component
{
    render()
    {
        return <Middle>Click upload to get started!</Middle>;
    }
}
